import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the fifth one it has got
  // wrong. The reference screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/ai-legacy-system-modernization/` on
  // 2026-08-28 and carry that address in their filenames, so the real slug is
  // the descriptive one rather than `the-new-renaissance`.
  'ai-legacy-system-modernization',
  'The New Renaissance: AI and Legacy System Modernization for Business Success',
  `${UPLOADS}/2024/11/legacy-system-modernization-ai-400x400.jpg`,
  {
    confirmed: true,
    download: pdf('ec2a18db-5e37-491c-8e1a-dc6d20ec0dc9-Reinventing Legacy in the Age of AI.pdf'),
    // Designed as its own written page on 2026-08-28, the seventh after
    // Transform Better, Agentic AI, Sustainability Innovation, Measurement,
    // AI in Fashion Retail and Generative AI — so the card goes there and
    // `prerender.tsx` skips it, rather than generating this template over the
    // top of it.
    href: '/en/impact-labs/ebooks/ai-legacy-system-modernization',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 6
